import type { OnboardingChatSummary } from "gsintegrations";

export type OnboardingEntityType = "terreiro_onboarding" | "medium_onboarding";

export interface OnboardingEditableField {
  key: string;
  label: string;
}

/** Single source of truth for onboarding chat bot editable fields (mirrors API registry). */
export const TERREIRO_EDITABLE_FIELDS: OnboardingEditableField[] = [
  { key: "firstName", label: "Nome" },
  { key: "lastName", label: "Sobrenome" },
  { key: "email", label: "E-mail" },
  { key: "phone", label: "Telefone" },
  { key: "terreiroName", label: "Nome do terreiro" },
  { key: "religionId", label: "Religião" },
  { key: "password", label: "Senha" },
];

export const MEDIUM_EDITABLE_FIELDS: OnboardingEditableField[] = [
  { key: "firstName", label: "Nome" },
  { key: "lastName", label: "Sobrenome" },
  { key: "email", label: "E-mail" },
  { key: "birthDate", label: "Data de nascimento" },
  { key: "phone", label: "Telefone" },
  { key: "guardianName", label: "Responsável" },
  { key: "guardianPhone", label: "Telefone do responsável" },
  { key: "guardianRelationship", label: "Parentesco do responsável" },
  { key: "documentType", label: "Tipo de documento" },
  { key: "document", label: "Documento" },
  { key: "street", label: "Rua" },
  { key: "number", label: "Número" },
  { key: "city", label: "Cidade" },
  { key: "state", label: "Estado" },
  { key: "zipCode", label: "CEP" },
  { key: "rankId", label: "Grau" },
  { key: "roleId", label: "Função" },
  { key: "password", label: "Senha" },
];

const MEDIUM_QUICK_FIELD_KEYS = new Set([
  "firstName",
  "lastName",
  "email",
  "birthDate",
  "phone",
  "guardianName",
  "guardianPhone",
  "guardianRelationship",
  "password",
]);

export const getOnboardingEditableFields = (
  entityType: OnboardingEntityType,
  isSocialAuth: boolean,
  mode: "quick" | "complete" = "quick",
): OnboardingEditableField[] => {
  let fields =
    entityType === "terreiro_onboarding"
      ? TERREIRO_EDITABLE_FIELDS
      : MEDIUM_EDITABLE_FIELDS;

  if (entityType === "medium_onboarding" && mode === "quick") {
    fields = fields.filter((field) => MEDIUM_QUICK_FIELD_KEYS.has(field.key));
  }

  if (isSocialAuth) {
    fields = fields.filter((field) => field.key !== "password");
  }

  return fields;
};

export const resolveOnboardingSummaryFieldValue = (
  key: string,
  summary?: OnboardingChatSummary,
): string | undefined => {
  if (!summary) return undefined;

  switch (key) {
    case "firstName":
      return summary.firstName;
    case "lastName":
      return summary.lastName;
    case "email":
      return summary.email;
    case "phone":
      return summary.phone;
    case "birthDate":
      return summary.birthDate;
    case "terreiroName":
      return summary.terreiroName;
    case "religionId":
      return summary.religionName;
    case "guardianName":
      return summary.guardianName;
    case "guardianPhone":
      return summary.guardianPhone;
    case "guardianRelationship":
      return summary.guardianRelationship;
    case "documentType":
      return summary.documentType;
    case "document":
      return summary.document;
    case "street":
      return summary.street;
    case "number":
      return summary.number;
    case "city":
      return summary.city;
    case "state":
      return summary.state;
    case "zipCode":
      return summary.zipCode;
    case "rankId":
      return summary.rankName;
    case "roleId":
      return summary.roleName;
    case "password":
      return summary.hasPassword ? "Senha definida" : undefined;
    default:
      return undefined;
  }
};

export const ONBOARDING_CHAT_BOT_TITLE = "Chatbot de cadastro";
export const ONBOARDING_CHAT_BOT_SUBTITLE =
  "Vamos criar sua conta conversando";
